import {atom} from 'jotai';
import {AISuggestionState} from 'plugins/aiRules/types';

// Global state for active AI suggestion (now includes DOM node reference)
export const activeAISuggestionAtom = atom<AISuggestionState | null>(null);
